/* eslint-disable */
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IOrgUnit } from '../interfaces/orgunit/IOrgUnit';
import { INotification } from '../interfaces/INotification';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class OrgUnitService {
  private http = inject(HttpClient);
  private notificationService = inject(NotificationService);

  private orgUnitsApi = environment.apiUrl + 'OrgaUnits/';

  public getOrgUnits(): Observable<IOrgUnit[]> {
    return this.http.get<IOrgUnit[]>(this.orgUnitsApi + 'GetAll').pipe(catchError(this.handleError<IOrgUnit[]>('getOrgUnits')));
  }

  public updateOrgUnit(orgUnit: IOrgUnit): Observable<void | HttpErrorResponse> {
    return this.http.post<void>(this.orgUnitsApi + 'Update', orgUnit);
  }

  public createOrgUnit(orgUnit: IOrgUnit): Observable<void | HttpErrorResponse> {
    return this.http.post<void>(this.orgUnitsApi + 'Create', orgUnit);
  }

  // TODO: Add message logging service
  private handleError<T>(operation?: string): (error: any) => Observable<T> {
    return (error: any): any => {
      const notification: INotification = {
        type: 'Error',
        title: 'default.error',
        desc: operation,
      };
      this.notificationService.showMessage(notification);

      console.error(error);
      return of(error as Observable<any>);
    };
  }
}
